import {Component, ElementRef, ViewChild} from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import {CallService} from '../call.service';

/**
 * Recording a call with everyone's consent (ITP-E-172-02). Mounted once, beside the call bar, it shows:
 * - the consent dialog when the host asks to record — Allow or Decline, where one decline cancels it for all — and,
 *   for a late joiner, before they hear anything: Allow and join, or Don't join;
 * - the persistent "Recording" indicator to everyone in the call while it records;
 * - to the host, "Waiting for everyone to allow recording…" and then who declined.
 * Meet's recording-consent-dialog only reminds a host of their duty; this asks every participant.
 */
@Component({
  selector: 'app-recording-consent',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  templateUrl: './recording-consent.component.html',
  styleUrls: ['./recording-consent.component.scss']
})
export class RecordingConsentComponent {
  readonly state$ = this.callService.state$;

  /** Allow takes the focus as the dialog appears, so the answer is one key away. */
  @ViewChild('allowButton')
  set allowButton(button: ElementRef<HTMLButtonElement> | undefined) {
    button?.nativeElement.focus();
  }

  constructor(private callService: CallService) {
  }

  onAllow(): void {
    this.callService.answerRecordingConsent(true).then();
  }

  onDecline(): void {
    this.callService.answerRecordingConsent(false).then();
  }

  onDismissNotice(): void {
    this.callService.dismissRecordingNotice();
  }
}
